import { useState, useEffect } from "react";
import { esFotoRawSinPreview, urlFotoCompleta, urlFotoGrid } from "../utils/fotoMultimediaUtils";

/**
 * Miniatura / preview de foto de captación.
 * RAW/DNG no se pueden pintar en &lt;img&gt;: placeholder inmediato (no descargar 25 MB).
 */
export default function CaptacionFotoThumb({
  foto,
  mode = "grid",
  /** Si true (parrilla Para revisar), no carga la foto completa si falta thumb. */
  soloThumb = false,
  alt = "",
  style,
  imgStyle,
  onClick,
  className,
  placeholderLabel,
}) {
  const raw = esFotoRawSinPreview(foto);
  const [fallo, setFallo] = useState(false);
  const preferred =
    mode === "full"
      ? (urlFotoCompleta(foto) || urlFotoGrid(foto) || foto?.url || "")
      : (urlFotoGrid(foto, { soloThumb }) || (soloThumb ? "" : (urlFotoCompleta(foto) || foto?.url || "")));
  const src = raw ? "" : preferred;
  useEffect(() => { setFallo(false); }, [src]);
  const showPh = raw || fallo || !src;

  if (showPh) {
    return (
      <div
        role={onClick ? "button" : undefined}
        tabIndex={onClick ? 0 : undefined}
        onClick={onClick}
        onKeyDown={onClick ? ((e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onClick(e);
          }
        }) : undefined}
        className={className}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 4,
          background: "#0f172a",
          color: "#cbd5e1",
          textAlign: "center",
          padding: 8,
          boxSizing: "border-box",
          cursor: onClick ? "pointer" : undefined,
          ...style,
        }}
      >
        <span style={{ fontSize: 11, fontWeight: 800, letterSpacing: 0.3 }}>
          {placeholderLabel || (raw ? "RAW / DNG" : (!src && !fallo ? "Miniatura…" : "Sin vista"))}
        </span>
        <span style={{ fontSize: 9, fontWeight: 500, color: "#94a3b8", lineHeight: 1.25 }}>
          {raw
            ? "Sin vista previa en el navegador · se puede insertar en Marco"
            : (fallo ? "No se pudo cargar la imagen" : "Borrador ligero en curso…")}
        </span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onClick={onClick}
      loading="lazy"
      decoding="async"
      onError={() => setFallo(true)}
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        ...style,
        ...imgStyle,
      }}
    />
  );
}
